import React, { Component } from 'react';
import CourseLink from '../CourseLink';
import signatureLogo from '../../img/signature-logo.png';
import ibslLogo from '../../img/ibsl-logo.png';
import stripePower from '../../img/powered-by-stripe.png';
import graphql from '../../helpers/graphql';
// import imgNaidexBanner from '../../img/naidex-banner.png';

class Footer extends Component {
  constructor (props) {
    super(props);
    this.state = {
      bslCourses: [],
      ibslCourses: [],
      sigCourses: []
    };
    graphql.getCourses().then((response) => {
      this.setState({
        bslCourses: this.getCoursesByCategory(response.courses, 'training'),
        ibslCourses: this.getCoursesByCategory(response.courses, 'ibsl'),
        sigCourses: this.getCoursesByCategory(response.courses, 'signature')
      });
    });
  }

  getCoursesByCategory (courses, category) {
    const filtered = courses.filter(
      (c) => c.category === category
    );
    return filtered;
  }
  render () {
    return (
      <footer className='site-footer'>
        <div className='l-container'>
          <div className='site-footer__top'>
            <div>
              <h4>BSL Training Courses</h4>
              <ul>
                {
                  this.state.bslCourses.map((course) => (
                    <CourseLink key={course.id} course={course} />
                  ))
                }
              </ul>
            </div>

            <div>
              <h4>iBSL Awards</h4>
              <ul>
                {
                  this.state.ibslCourses.map((course) => (
                    <CourseLink key={course.id} course={course} />
                  ))
                }
              </ul>
            </div>

            <div>
              <h4>Signature Awards</h4>
              <ul>
                {
                  this.state.sigCourses.map((course) => (
                    <CourseLink key={course.id} course={course} />
                  ))
                }
              </ul>
            </div>

            <div className='right'>
              <h4>Information</h4>
              <ul>
                <li><a href='/tour'>How it works</a></li>
                <li><a href='/about'>About us</a></li>
                <li><a href='http://support.bslcourses.co.uk/' target='_blank' rel='noopener noreferrer'>Support</a></li>
                <li><a href='/contact'>Contact</a></li>
                <li><a href='https://s3-eu-west-1.amazonaws.com/static.bslcourses.co.uk/pdfs/bsl-terms.pdf' target='_blank'  rel='noopener noreferrer'>Terms</a></li>
                <li><a href='https://s3-eu-west-1.amazonaws.com/static.bslcourses.co.uk/pdfs/bsl-privacy.pdf' target='_blank'  rel='noopener noreferrer'>Privacy</a></li>
              </ul>
            </div>
          </div>

          {/* <div className='site-footer__promo'>
            <a className='site-footer__naidex' href='http://www.naidex.co.uk/exhibitors/bslcoursescouk-ltd/' target='_blank' rel='noopener noreferrer' title='Click to visit the Naidex website for more details'>
              <img src={imgNaidexBanner} alt='Visit us at Naidex' />
            </a>
          </div>*/}

          <div className='site-footer__logos'>
            <a href='http://www.signature.org.uk' target='_blank' rel='noopener noreferrer'><img src={signatureLogo} alt='Signature logo' /></a>
            <a href='http://ibsl.org.uk' target='_blank' rel='noopener noreferrer'><img src={ibslLogo} alt='iBSL logo' /></a>
          </div>

          <div className='site-footer__bottom'>
            <div className='left'>
              <a href='https://stripe.com/gb' target='_blank' rel='noopener noreferrer'><img src={stripePower} alt='Powered by Stripe' /></a>
              <p>We accept all major credit and debit cards as well as bank transfer.</p>
            </div>

            <p className='right'>
              © Copyright 2017 BSLcourses.co.uk. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js